import React from "react";
import { enqueueSnackbar } from "notistack";
import { Modal3 } from "../../DIsplay/Modal/Modal3";
import CommonFreeTextInput from "../../common/inputs/CommonFreeTextInput";
import Button1 from "../../form/Button1";

function TicketEditGdsPnrModal({ open, setOpen, initialValue, handleSave }) {
  const [inputValue, setInputValue] = React.useState(initialValue ?? "");

  React.useEffect(() => {
    if (open) {
      const sanitized = (initialValue ?? "").replace(/[^a-zA-Z0-9]/g, "");
      setInputValue(sanitized);
    }
  }, [open, initialValue]);

  const handleInputChange = (value) => {
    const lettersAndNumbersOnly = (value ?? "").replace(/[^a-zA-Z0-9]/g, "");
    setInputValue(lettersAndNumbersOnly);
  };

  const onSave = () => {
    const trimmed = inputValue?.trim();
    if (!trimmed) {
      enqueueSnackbar("GDS PNR is required.", { variant: "warning" });
      return;
    }
    handleSave(trimmed);
  };

  return (
    <div>
      <Modal3 open={open} setOpen={setOpen} title="Edit GDS PNR">
        <div className="card p-6 flex flex-col gap-5 w-96">
          <CommonFreeTextInput
            value={inputValue}
            onChange={(value) => handleInputChange(value)}
            label="GDS PNR"
          />

          <div className="flex gap-3 items-center justify-end">
            <Button1
              variant="outlined"
              className="whitespace-nowrap"
              onClick={() => setOpen(false)}
            >
              Cancel
            </Button1>
            <Button1 onClick={onSave}>Save GDS PNR</Button1>
          </div>
        </div>
      </Modal3>
    </div>
  );
}

export default TicketEditGdsPnrModal;
